<form fxLayout="column" fxFlex="100" [formGroup]="form">
  <mat-form-field>
    <input matInput type="text" formControlName="internetAdresa" placeholder="{{
          translatePrefix + 'internetAdresa' | translate
        }}" maxlength="200" />
  </mat-form-field>
  <mat-form-field>
    <input matInput type="text" formControlName="adresaEPoste" placeholder="{{
          translatePrefix + 'adresaEPoste' | translate
        }}" maxlength="100" />
    <mat-error *ngIf="adresaEPoste?.invalid">
      <span *ngIf="adresaEPoste?.errors['pattern']">
        {{ generalErrors + 'txtMailPattern' | translate }}</span>
    </mat-error>
  </mat-form-field>
  <mat-form-field>
    <input matInput type="text" formControlName="telefon" maxlength="50"
      placeholder="{{ translatePrefix + 'telefon' | translate }}" />
  </mat-form-field>
</form>